export default "__VITE_ASSET__DLSXk_Wm__"